import { render, staticRenderFns } from "./stat-slab.vue?vue&type=template&id=5a04077c"
import script from "./stat-slab.vue?vue&type=script&lang=js"
export * from "./stat-slab.vue?vue&type=script&lang=js"
import style0 from "./stat-slab.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports